import { ACLContextType } from './ACL.types';

export const initialState: ACLContextType = {
  isTrial: false,
  isRoleResolved: false,
  userIsOwner: false,
  userIsAdmin: false,
  userIsSeller: false,
  userIsViewer: false,
  isLegacyPlan: false,
  isBusinessPlan: false,
  isGrowthPlan: false,
  isAdvancedPlan: false,
  activeLeadsLimit: 0,
  activeLeadsCount: 0,
  maxFunnelCount: 0,
  storageLimit: 0,
  watermarkRemoval: false,
  watermarkRemovalId: null,
  leadbotLevelsAccessId: null,
  leadLimitAddonId: null,
  marketingMessageVolume: 0,
  apiKeyAccess: false,
  templateCreditsLimit: 0,
  templateCreditsPlanLimit: 0,
  templateCreditsLimitFeatureId: null,
  whatsAppApiAccess: false,
  canEditInteractiveFooter: false,
  leadbotLevelsAccess: false,
  liveSupportAccess: false,
  whatsAppApiAnalyticsAccess: false,
  leadbotLevelsAccessFeature: undefined,
  liveSupportAccessFeature: undefined,
  watermarkRemovalFeature: undefined,
  canUserCreateNewFunnel: () => false,
  canUserEditFunnels: () => false,
  canUserOpenAutoAssignModal: () => false,
  canLeadsBeCreatedOrActivated: () => false,
  canUserUploadToStorage: () => false,
  canUserChatWithHumanSupport: () => false,
  canUserSendMessagesInBulkInFunnel: () => false,
  canWorkspaceHaveFreeTrial: () => false,
  canUserAccessLeadbotLevels: () => false,
  canUserAccessWhatsAppApi: () => false,
  canUserAccessWhatsAppWebQr: () => false,
  canUserAccessTikTok: () => false,
  canUserSeeComingSoonTikTok: () => false,
  canSendOutboundMessages: true,
};
